import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import LoginModal from '../components/LoginModal';  

import {
  FaUser,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaPaperPlane,
  FaArrowRight,
  FaHeadset,
  FaSearch,
  FaBuilding,
} from "react-icons/fa";
import hireCuraIcon from "../assets/hirecura-icon.png";

import Footer from "../components/Footer";
import healthcareHero from "../assets/contact-us-hero.png";

function ContactUs() {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginRole, setLoginRole] = useState("candidate");

const openLoginModal = (role) => {
  setLoginRole(role);
  setShowLoginModal(true);
};

  const [loggedUser, setLoggedUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    alert(
      "Thank you for contacting HireCura. Our team will get back to you soon."
    );

    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-white">

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">

          <div className="flex min-w-0 items-center justify-between gap-2">

            {/* LOGO */}
            {/* LOGO */}
<div
  className="cursor-pointer flex min-w-0 items-center gap-2 sm:gap-3 flex-shrink-0"
  onClick={() =>
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
>
  {/* HireCura Icon */}
  <img
    src={hireCuraIcon}
    alt="HireCura Icon"
    className="h-9 w-9 sm:h-11 sm:w-11 md:h-12 md:w-12 object-contain"
  />

  {/* Brand Name and Tagline */}
  <div className="flex flex-col">
    <h1 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight leading-none">
      <span className="text-slate-900">Hire</span>
      <span className="text-teal-600">Cura</span>
    </h1>

    <p className="text-[9px] sm:text-[10px] md:text-xs text-slate-500 font-medium tracking-wide mt-1">
      Where Careers Meet Care.
    </p>
  </div>
</div>

            {/* NAVIGATION */}
            <nav className="hidden lg:flex items-center gap-8">

              <button
                onClick={() => navigate("/")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Home
              </button>

              <button
                onClick={() => navigate("/find-jobs")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Find Jobs
              </button>

                {loggedUser?.role !== "candidate" && (
  <button
    onClick={() => navigate("/for-employers")}
    className="text-gray-700 hover:text-teal-600 transition font-medium"
  >
    For Employers
  </button>
)}

              <button
                onClick={() => navigate("/how-it-works")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                How It Works
              </button>

              <button
                onClick={() => navigate("/about-us")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                About Us
              </button>

              {/* ACTIVE */}
              <button
                className="relative text-teal-600 font-semibold"
              >
                Contact Us

                <span className="absolute -bottom-5 left-0 right-0 h-[3px] bg-teal-600 rounded-full" />
              </button>

            </nav>

            {/* RIGHT SIDE */}
            <div className="hidden md:flex items-center gap-4">
  {loggedUser ? (
    <>
      <FaUser className="text-[#10243e] text-lg" />
      
            <span className="hidden xl:block text-sm font-semibold text-gray-700">
        Welcome, {loggedUser.name || "User"}
      </span>

      <button
        onClick={() =>
          navigate(
            loggedUser.role === "institution"
              ? "/institution"
              : "/candidate-dashboard"
          )
        }
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Dashboard
      </button>

      <button
        onClick={() => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          setLoggedUser(null);
          navigate("/");
        }}
        className="border border-red-500 text-red-600 px-5 py-2 rounded-full hover:bg-red-50 transition"
      >
        Logout
      </button>
    </>
  ) : (
    <>
    <FaUser className="text-[#10243e] text-lg" />
      <button
       onClick={() => openLoginModal("candidate")}
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Login
      </button>

      <button
        onClick={() => openLoginModal("institution")}
        className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition"
      >
        Post a Job
      </button>
    </>
  )}
</div>

            <MobileMenu
              onLogin={() => openLoginModal("candidate")}
              loggedUser={loggedUser}
              onLogout={() => {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                setLoggedUser(null);
                navigate("/");
              }}
            />
          </div>

        </div>
      </header>


      {/* ================= HERO ================= */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-[#f3fbfa] to-[#dff5f1]">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="grid lg:grid-cols-2 gap-6 lg:gap-10 items-center min-h-0 lg:min-h-[350px]">

            {/* LEFT */}
            <div className="relative z-10 py-8 sm:py-10 lg:py-12">

              <p className="text-xs sm:text-sm md:text-base tracking-[0.16em] sm:tracking-[0.18em] text-[#10243e] font-medium mb-3 sm:mb-4">
                CONTACT HIRECURA
              </p>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight sm:leading-[1.08] text-[#10243e]">

                We're Here
                <br />

                <span className="text-teal-600">
                  to Help
                </span>

              </h1>

              <p className="mt-4 sm:mt-5 text-base sm:text-lg text-gray-600 max-w-xl leading-6 sm:leading-7">
                Have a question, need assistance or want to learn more
                about HireCura? Our team is here to help.
              </p>

            </div>


            {/* RIGHT IMAGE */}
            <div className="relative hidden md:flex justify-end items-end h-full min-h-[350px]">

              <div className="absolute right-[-80px] bottom-0 w-[580px] h-[320px] bg-teal-100/70 rounded-t-full" />

              <img
                src={healthcareHero}
                alt="HireCura healthcare support"
                className="relative z-10 w-full max-w-[520px] h-[320px] object-cover object-top rounded-t-[180px]"
              />

            </div>

          </div>

        </div>

      </section>


      {/* ================= CONTACT CONTENT ================= */}
      <section className="bg-white py-8 sm:py-10 md:py-16">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-5 sm:gap-8">


            {/* ================= CONTACT INFO ================= */}
            <div className="bg-[#f3fbfa] rounded-2xl sm:rounded-3xl p-5 sm:p-7 md:p-9">

              <p className="text-sm uppercase tracking-[0.18em] text-teal-600 font-semibold">
                Get In Touch
              </p>

              <h2 className="text-2xl sm:text-3xl font-bold text-[#10243e] mt-2">
                Let's Talk
              </h2>

              <p className="text-gray-600 mt-4 leading-6">
                Whether you're a healthcare professional looking for
                opportunities or an organization looking for talent,
                we'd love to hear from you.
              </p>


              {/* LOCATION */}
              <div className="flex items-start gap-3 sm:gap-4 mt-6 sm:mt-8">

                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                  <FaMapMarkerAlt className="text-teal-600 text-lg sm:text-xl" />
                </div>

                <div>
                  <h3 className="font-bold text-[#10243e]">
                    Location
                  </h3>

                  <p className="text-gray-600 mt-1">
                    Hyderabad, Telangana, India
                  </p>
                </div>

              </div>


              {/* PHONE */}
              <div className="flex items-start gap-3 sm:gap-4 mt-5 sm:mt-6">

                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                  <FaPhoneAlt className="text-teal-600 text-lg sm:text-xl" />
                </div>

                <div>
                  <h3 className="font-bold text-[#10243e]">
                    Phone
                  </h3>

                  <p className="text-gray-600 mt-1">
                    +91 7386 7387 68
                  </p>
                </div>

              </div>


              {/* EMAIL */}
              <div className="flex items-start gap-3 sm:gap-4 mt-5 sm:mt-6">

                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                  <FaEnvelope className="text-teal-600 text-lg sm:text-xl" />
                </div>

                <div>
                  <h3 className="font-bold text-[#10243e]">
                    Email
                  </h3>

                  <p className="text-gray-600 mt-1">
                    support@hirecura.com
                  </p>
                </div>

              </div>


              {/* HOURS */}
              <div className="flex items-start gap-3 sm:gap-4 mt-5 sm:mt-6">

                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                  <FaClock className="text-teal-600 text-lg sm:text-xl" />
                </div>

                <div>
                  <h3 className="font-bold text-[#10243e]">
                    Support Hours
                  </h3>

                  <p className="text-gray-600 mt-1">
                    Monday – Saturday | 9 AM – 6 PM
                  </p>
                </div>

              </div>


              {/* SUPPORT CARD */}
              <div className="mt-6 sm:mt-8 bg-white rounded-2xl p-4 sm:p-5 flex items-start sm:items-center gap-3 sm:gap-4">

                <div className="w-12 h-12 rounded-full bg-[#e5f8f4] flex items-center justify-center">
                  <FaHeadset className="text-teal-600 text-lg sm:text-xl" />
                </div>

                <div>
                  <h3 className="font-bold text-[#10243e]">
                    Need quick assistance?
                  </h3>

                  <p className="text-sm text-gray-500 mt-1">
                    Send us a message and our team will get back to you.
                  </p>
                </div>

              </div>

            </div>


            {/* ================= CONTACT FORM ================= */}
            <div className="bg-white rounded-2xl sm:rounded-3xl border border-gray-100 shadow-sm p-5 sm:p-7 md:p-9">

              <div className="flex items-start sm:items-center gap-3 mb-5 sm:mb-7">

                <div className="w-12 h-12 rounded-xl bg-[#e5f8f4] flex items-center justify-center">
                  <FaPaperPlane className="text-teal-600 text-lg sm:text-xl" />
                </div>

                <div>
                  <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#10243e]">
                    Send Us a Message
                  </h2>

                  <p className="text-sm text-gray-500 mt-1">
                    Fill in the details below and we'll get back to you.
                  </p>
                </div>

              </div>


              <form
                onSubmit={handleSubmit}
                className="space-y-4 sm:space-y-5"
              >

                {/* NAME + EMAIL */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">

                  <div>
                    <label className="block text-sm font-semibold text-[#10243e] mb-2">
                      Full Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                      className="w-full min-w-0 border border-gray-200 rounded-xl px-3 sm:px-4 py-3 text-base outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-100"
                    />
                  </div>


                  <div>
                    <label className="block text-sm font-semibold text-[#10243e] mb-2">
                      Email Address
                    </label>

                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                      className="w-full min-w-0 border border-gray-200 rounded-xl px-3 sm:px-4 py-3 text-base outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-100"
                    />
                  </div>

                </div>


                {/* PHONE + SUBJECT */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">

                  <div>
                    <label className="block text-sm font-semibold text-[#10243e] mb-2">
                      Phone Number
                    </label>

                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 XXXXX XXXXX"
                      className="w-full min-w-0 border border-gray-200 rounded-xl px-3 sm:px-4 py-3 text-base outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-100"
                    />
                  </div>


                  <div>
                    <label className="block text-sm font-semibold text-[#10243e] mb-2">
                      Subject
                    </label>

                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="w-full min-w-0 border border-gray-200 rounded-xl px-3 sm:px-4 py-3 text-base bg-white outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-100"
                    >
                      <option value="">
                        Select a subject
                      </option>

                      <option value="Job Seeker Support">
                        Job Seeker Support
                      </option>

                      <option value="Employer Support">
                        Employer Support
                      </option>

                      <option value="Job Posting">
                        Job Posting
                      </option>

                      <option value="Partnership">
                        Partnership
                      </option>

                      <option value="General Inquiry">
                        General Inquiry
                      </option>

                    </select>
                  </div>

                </div>


                {/* MESSAGE */}
                <div>

                  <label className="block text-sm font-semibold text-[#10243e] mb-2">
                    Message
                  </label>

                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="How can we help you?"
                    rows="6"
                    required
                    className="w-full min-w-0 border border-gray-200 rounded-xl px-3 sm:px-4 py-3 text-base outline-none resize-y focus:border-teal-500 focus:ring-1 focus:ring-teal-100"
                  />

                </div>


                {/* SUBMIT */}
                <button
                  type="submit"
                  className="w-full bg-teal-600 hover:bg-teal-700 text-white py-3.5 rounded-xl font-semibold flex items-center justify-center gap-3 transition"
                >
                  Send Message
                  <FaArrowRight className="text-sm" />
                </button>

              </form>

            </div>

          </div>

        </div>

      </section>


      {/* ================= QUICK LINKS ================= */}
      <section className="bg-[#f8fbfb] py-8 sm:py-10 md:py-12">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="text-center">

            <p className="text-sm uppercase tracking-[0.18em] text-teal-600 font-semibold">
              Looking for something else?
            </p>

            <h2 className="text-2xl md:text-3xl font-bold text-[#10243e] mt-2">
              Explore HireCura
            </h2>

          </div>


          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 mt-6 sm:mt-8">

            {/* FIND JOBS */}
            <button
              onClick={() => navigate("/find-jobs")}
              className="w-full min-w-0 bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 text-left hover:border-teal-200 hover:shadow-md transition group"
            >

              <FaSearch className="text-3xl text-teal-600" />

              <h3 className="text-xl font-bold text-[#10243e] mt-4">
                Find Jobs
              </h3>

              <p className="text-gray-500 mt-2">
                Explore healthcare opportunities across India.
              </p>

              <span className="text-teal-600 font-semibold mt-4 inline-flex items-center gap-2">
                Explore Jobs
                <FaArrowRight className="text-sm group-hover:translate-x-1 transition" />
              </span>

            </button>


            {/* EMPLOYERS */}
            <button
              onClick={() => navigate("/for-employers")}
              className="w-full min-w-0 bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 text-left hover:border-teal-200 hover:shadow-md transition group"
            >

              <FaBuilding className="text-3xl text-teal-600" />

              <h3 className="text-xl font-bold text-[#10243e] mt-4">
                For Employers
              </h3>

              <p className="text-gray-500 mt-2">
                Find qualified healthcare professionals for your team.
              </p>

              <span className="text-teal-600 font-semibold mt-4 inline-flex items-center gap-2">
                Hire Talent
                <FaArrowRight className="text-sm group-hover:translate-x-1 transition" />
              </span>

            </button>


            {/* HOW IT WORKS */}
            <button
              onClick={() => navigate("/how-it-works")}
              className="w-full min-w-0 bg-white border border-gray-100 rounded-2xl p-5 sm:p-6 text-left hover:border-teal-200 hover:shadow-md transition group"
            >

              <FaHeadset className="text-3xl text-teal-600" />

              <h3 className="text-xl font-bold text-[#10243e] mt-4">
                How It Works
              </h3>

              <p className="text-gray-500 mt-2">
                Learn how HireCura connects professionals and employers.
              </p>

              <span className="text-teal-600 font-semibold mt-4 inline-flex items-center gap-2">
                Learn More
                <FaArrowRight className="text-sm group-hover:translate-x-1 transition" />
              </span>

            </button>

          </div>

        </div>

      </section>


      {/* ================= FOOTER ================= */}
      <Footer />
      <LoginModal
  isOpen={showLoginModal}
  initialRole={loginRole}
  onClose={() => setShowLoginModal(false)}
/>
      

    </div>
  );
}

export default ContactUs;